export const STEP_MAIN_ORGANIZATION = 'main organization';
export const STEP_TENANT = 'tenant';
export const STEP_ORGANIZATION = 'organization';
export const STEP_MODULE = 'module';
export const STEP_USER = 'user';
export const STEP_AREA = 'area';
export const STEP_BED = 'bed';
export const STEP_DEVICE = 'device';
export const STEP_MAP = 'map';

export const STEP_MANAGE_ORGANIZATION = 'manage organization';
export const STEP_MANAGE_USER = 'manage user';
export const STEP_MANAGE_AREA = 'manage area';
export const STEP_MANAGE_BED = 'manage bed';
export const STEP_MANAGE_DEVICE = 'manage device';
export const STEP_MANAGE_MAP = 'manage map';

export const FLOW_DEFAULT = 'default';
export const FLOW_GROUP = 'group';
export const FLOW_USER = 'user';
export const FLOW_AREA = 'area';
export const FLOW_BED = 'bed';
export const FLOW_DEVICE = 'device';
export const FLOW_MAP = 'map';
